import {IRect, LengthUnit, TextDirection} from '@colibrio/colibrio-reader-framework/colibrio-core-base';
import {
    IEngineEventTargetXmlElementNodeData,
    IMouseEngineEventData,
    IPointerEngineEventData,
    ISyncMediaPlaybackRangeOptions,
    ITransformRectZoomOptions,
    IVisibleContentRectData,
    NavigationCollectionType,
} from '@colibrio/colibrio-reader-framework/colibrio-readingsystem-base';

import {VanillaReaderEventBus} from '../VanillaReaderEventBus/VanillaReaderEventBus';
import {
    IVanillaReaderContentPositionData,
    IVanillaReaderEscapableContentBlockDataContext,
    IVanillaReaderHighlightData,
    IVanillaReaderNavigationItem,
    IVanillaReaderNavigationTreeData,
    IVanillaReaderPublicationData,
    IVanillaReaderPublicationStateData,
    IVanillaReaderPublicationStyleOptions,
    IVanillaReaderReadingProgressionTimelineData,
    IVanillaReaderSyntheticPageData,
    IVanillaReaderSyntheticPageListData,
    IVanillaReaderTransformData,
    IVanillaReaderTtsOptions,
    IVanillaReaderUiColorTheme,
    IVanillaReaderVisibleRangeData,
    IVanillaSyncMediaPlaybackStateData,
    VanillaReaderNavigationType,
    VanillaReaderPaginationType,
    VanillaReaderPublicationLandmarkType,
    VanillaReaderRendererNames,
} from '../VanillaReader/VanillaReaderModel';
import {IVanillaReaderOptionsDataStore} from '../VanillaReaderDataStore/IVanillaReaderOptionsDataStore';
import {VanillaReaderAppUiDefaults} from './VanillaReaderAppUiDefaults';
import {VanillaReaderUiButtonMenu} from './VanillaReaderUiButtonMenu';
import {VanillaReaderUiDialogBookmarks} from './VanillaReaderUiDialogBookmarks';
import {VanillaReaderUiDialogContents} from './VanillaReaderUiDialogContents';
import {VanillaReaderUiDialogFootnote} from './VanillaReaderUiDialogFootnote';
import {VanillaReaderUiDialogHelp} from './VanillaReaderUiDialogHelp';
import {VanillaReaderUiDialogHighlight} from './VanillaReaderUiDialogHighlight';
import {VanillaReaderUiDialogHighlights} from './VanillaReaderUiDialogHighlights';
import {VanillaReaderUiDialogImageViewer} from './VanillaReaderUiDialogImageViewer';
import {VanillaReaderUiDialogOpenFile} from './VanillaReaderUiDialogOpenFile';
import {VanillaReaderUiDialogSearch} from './VanillaReaderUiDialogSearch';
import {VanillaReaderUiDialogSettings} from './VanillaReaderUiDialogSettings';
import {VanillaReaderUiFabHighlight} from './VanillaReaderUiFabHighlight';
import {VanillaReaderUiFabMediaPlayer} from './VanillaReaderUiFabMediaPlayer';
import {VanillaReaderUiMenuMediaPlayer} from './VanillaReaderUiMenuMediaPlayer';
import {VanillaReaderUiMenu} from './VanillaReaderUiMenu';
import {VanillaReaderUiToaster} from './VanillaReaderUiToaster';
import {VanillaReaderUiDialogActions} from "./VanillaReaderUiDialogUIActions";
import {VanillaReaderUiKeyboardShortcutController} from "./VanillaReaderUiKeyboardShortcutController";
import {IVanillaReaderUiOptionsData} from "./VanillaReaderUiModel";
import {VanillaReaderUiMenuMediaPlayerController} from "./VanillaReaderUiMenuMediaPlayerController";
import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUiMenuController} from "./VanillaReaderUiMenuController";
import {VanillaReaderUiMediaSessionsController} from "./VanillaReaderUiMediaSessionsController";
import {VanillaReaderUiDialogHighlightController} from "./VanillaReaderUiDialogHighlightController";
import {VanillaReaderUiDialogHighlightsController} from "./VanillaReaderUiDialogHighlightsController";
import {VanillaReaderUiDialogSettingsController} from "./VanillaReaderUiDialogSettingsController";
import {VanillaReaderUiVanillaReaderEventController} from "./VanillaReaderUiVanillaReaderEventController";
import {VanillaReaderUiDialogBookmarksController} from "./VanillaReaderUiDialogBookmarksController";
import {VanillaReaderUiDialogOpenFileController} from "./VanillaReaderUiDialogOpenFileController";
import {VanillaReaderUiDialogFootnoteController} from "./VanillaReaderUiDialogFootnoteController";
import {VanillaReaderUiDialogController} from "./VanillaReaderUiDialogController";
import {VanillaReaderUiDialogImageViewerController} from "./VanillaReaderUiDialogImageViewerController";
import {VanillaReaderUiDialogSearchController} from "./VanillaReaderUiDialogSearchController";
import {ICoordinates} from "../utils/ICoordinates";
import {VanillaReaderUiFabHighlightController} from "./VanillaReaderUiFabHighlightController";
import {VanillaReaderUiFabMediaPlayerController} from "./VanillaReaderUiFabMediaPlayerController";
import {VanillaReaderUiDialogContentsController} from "./VanillaReaderUiDialogContentsController";
import {VanillaReaderUiDialogUiActionsController} from "./VanillaReaderUiDialogUiActionsController";
import {VanillaReaderUiReadingRuler} from "./VanillaReaderUiReadingRuler";
import {VanillaReaderUiReadingRulerController} from "./VanillaReaderUiReadingRulerController";
import {VanillaReaderUiButtonMenuController} from "./VanillaReaderUiButtonMenuController";
import {VanillaReaderUiButtonNextController} from "./VanillaReaderUiButtonNextController";
import {VanillaReaderUiPanZoomToolController} from "./VanillaReaderUiPanZoomToolController";
import {VanillaReaderUiButtonPreviousController} from "./VanillaReaderUiButtonPreviousController";
import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {VanillaReaderUiPanZoomTool} from "./VanillaReaderUiPanZoomTool";
import {VanillaReaderShelfItem} from "../VanillaReaderBookshelf/VanillaReaderShelfItem";
import {VanillaReaderBookshelf} from "../VanillaReaderBookshelf/VanillaReaderBookshelf";
import {
    IEpubReaderPublicationOptions
} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-epub";
import {
    IWpAudiobookReaderPublicationOptions
} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-wp-audiobook";
import {
    IPdfReaderPublicationOptions
} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-formatadapter-pdf";
import {VanillaReaderUiSliderProgression} from "./VanillaReaderUiSliderProgression";
import {VanillaReaderUiSliderProgressionController} from "./VanillaReaderUiSliderProgressionController";
import {VanillaReaderUiLabelPageNumber} from "./VanillaReaderUiLabelPageNumber";
import {VanillaReaderUiLabelPageNumberController} from "./VanillaReaderUiLabelPageNumberController";
import {VanillaReaderUiDialogPublicationLandmarks} from "./VanillaReaderUiDialogPublicationLandmarks";
import {
    VanillaReaderUiDialogPublicationLandmarksController
} from "./VanillaReaderUiDialogPublicationLandmarksController";
import {
    IVanillaReaderAppEvent_APP_UI_OPTIONS_RESET,
} from '../VanillaReaderEventBus/IVanillaReaderAppEventTypeMap';
import {ISimpleLocatorData} from "@colibrio/colibrio-reader-framework/colibrio-core-locator";
import {VanillaReaderUiFabSpeakText} from "./VanillaReaderUiFabSpeakText";
import {VanillaReaderUiFabSpeakTextController} from "./VanillaReaderUiFabSpeakTextController";
import {WebSpeechTtsSynthesizer} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-engine";
import {VanillaReaderUiDialogNavigationHistory} from "./VanillaReaderUiDialogNavigationHistory";
import {VanillaReaderUiDialogNavigationHistoryController} from "./VanillaReaderUiDialogNavigationHistoryController";
import {VanillaReaderAppAssets} from "../VanillaReaderApp/VanillaReaderAppAssets";
import {VanillaReaderLandmark} from "../VanillaReader/VanillaReaderLandmark";
import {VanillaReaderAPI} from "../VanillaReaderAPI/VanillaReaderAPI";
import {WebSpeechUtils} from "../utils/WebSpeechUtils";
import {ObjectUtils} from "../utils/base/ObjectUtils/ObjectUtils";
import { MasterPlanUiStart } from '../MasterPlanUI/MasterPlanUIStart';
import { MasterPlanUIStartController } from '../MasterPlanUI/MasterPlanUIStartController';
import { VanillaReaderUiFunctionButtons } from './VanillaReaderUiFunctionButtons';
import { VanillaReaderUiFunctionButtonsController } from './VanillaReaderUiFunctionButtonsController';
import { VanillaReaderUiSideMenu } from './VanillaReaderUiSideMenu';
import { VanillaReaderUiSideMenuController } from './VanillaReaderUiSideMenuController';

/**
 * # VanillaReaderUI
 *
 * ## RESPONSIBILITIES
 *
 * This is the main class, and also root container, for the Vanilla Reader UI.
 *
 * This UI class, or any of its child components, knows nothing about the Colibrio Reader Framework. All the Colibrio related
 * logic is in the `VanillaReader` module of this project.
 *
 * ## COMPONENT AND CONTROLLER MIXINS
 *
 * The app UI is composed of components of code, defined by their scope of functionality. As an example, each of the
 * dialogs in the app have their own component, such as the `VanillaReaderUiDialogHighlights` class. Component behavior
 * is exposed to the `VanillaReaderUI` (this file) using callbacks, such as `menu.onNavigateNext` and `dialogHighlight.onAddHighlight.`
 *
 * To make this file easier to work with, each component has its own `VanillaReaderUi...Controller` class which separates
 * out component specific code from the main UI code. The controllers are added to the VanillaReaderUI class at runtime
 * using a mixin pattern approach (check out the `_applyUiControllerMixins` method).
 *
 * You can think of this strategy of code splitting using mixins as being similar to Partial Classes in C#.
 *
 * ## NOTE ON THE ARCHITECTURE
 *
 * To keep a clear separation between the application logic in VanillaReader module and the UI element logic
 * in this file, all application functionality is exposed through a public API, the VanillaReaderAPI.
 *
 * When the GUI has something it wants the VanillaReader (and the Colibrio Reader Framework) to do, it calls a
 * method on the API instance. When the state within the VanillaReader module updates it will dispatch an event
 * which in turn will trigger a callback on the VanillaReaderAPI instance.
 *
 *
 *      |-----------------------|                   |-----------------------|
 *      |                       |   -- method ->    |                       |
 *      |   VanillaReaderUI     |                   |   VanillaReaderAPI    |
 *      |                       |   <- callback --  |                       |
 *      |-----------------------|                   |-----------------------|
 *
 *
 * All VanillaReaderAPI callbacks are registered and handled in the VanillaReaderUiVanillaReaderEventController.
 *
 * ## SWAPPABILITY
 *
 * Thanks to the very clear separation of concern, and thanks to the intent/update strategy, it will be easy to swap out
 * the `VanillaReaderUI` to any other frontend tech, such as React or Vue. Not that there is anything wrong with vanilla
 * HTML and CSS of course 🙂
 *
 */

export class VanillaReaderUI implements IVanillaReaderUI {

    useDeviceStorage: boolean = false;
    webSpeechPlayerForTextSelections: WebSpeechTtsSynthesizer | undefined;

    /**
     *
     * Initial options data and state that is provided to the UI at application startup.
     *
     * */
    initialPublicationData: IVanillaReaderPublicationData | undefined;
    initialReadingPositionData: IVanillaReaderContentPositionData | undefined;
    initialVanillaReaderUiOptionsData: IVanillaReaderUiOptionsData | undefined;

    /**
     *
     * Application UI elements. These elements are accessible to all `VanillaReaderUi*Controller` classes.
     *
     * */

    vanillaReaderUIElement: HTMLElement;
    vanillaReaderViewElement: HTMLElement;
    vanillaReaderFabContainerElement: HTMLElement;
    vanillaReaderButtonContainerElement: HTMLElement;
    vanillaReaderSliderContainerElement: HTMLElement;
    menuMediaPlayer: VanillaReaderUiMenuMediaPlayer;
    menuProgressionSlider: VanillaReaderUiSliderProgression;
    dialogContents: VanillaReaderUiDialogContents;
    dialogSettings: VanillaReaderUiDialogSettings;
    dialogHighlight: VanillaReaderUiDialogHighlight;
    dialogOpenFile: VanillaReaderUiDialogOpenFile;
    masterplanStart: MasterPlanUiStart;
    dialogHighlights: VanillaReaderUiDialogHighlights;
    dialogBookmarks: VanillaReaderUiDialogBookmarks;
    dialogSearch: VanillaReaderUiDialogSearch;
    dialogImageViewer: VanillaReaderUiDialogImageViewer;
    dialogHelp: VanillaReaderUiDialogHelp;
    dialogFootnote: VanillaReaderUiDialogFootnote;
    dialogUiActions: VanillaReaderUiDialogActions;
    dialogLandmarks: VanillaReaderUiDialogPublicationLandmarks;
    menuBottom: VanillaReaderUiMenu;
    menuSide: VanillaReaderUiSideMenu;
    toaster: VanillaReaderUiToaster;
    fabHighlight: VanillaReaderUiFabHighlight;
    fabSpeakText: VanillaReaderUiFabSpeakText;
    fabMediaPlayer: VanillaReaderUiFabMediaPlayer;
    //buttonPrevious: VanillaReaderUiButtonPrevious;
    //buttonNext: VanillaReaderUiButtonNext;
    buttonMenu: VanillaReaderUiButtonMenu;
    readingRuler: VanillaReaderUiReadingRuler;
    panZoomTool: VanillaReaderUiPanZoomTool;
    labelPageNumber: VanillaReaderUiLabelPageNumber;
    functionButtons: VanillaReaderUiFunctionButtons;
    ambientMediaAudio: HTMLAudioElement | undefined;

    /**
     *
     * VanillaReader runtime state variables. These variables are set in the `VanillaReaderUiVanillaReaderEventController`
     * class in response to events and callbacks and should be considered as immutable by the rest of the UI logic.
     *
     * These fields are accessible to all `VanillaReaderUi*Controller` classes.
     *
     * */

    publicationHeadingLandmarks: VanillaReaderLandmark[] | undefined;
    publicationFootnoteLandmarks: VanillaReaderLandmark[] | undefined;
    publicationFigureLandmarks: VanillaReaderLandmark[] | undefined;
    publicationListLandmarks: VanillaReaderLandmark[] | undefined;
    publicationTableLandmarks: VanillaReaderLandmark[] | undefined;
    publicationNavigationTreeData: IVanillaReaderNavigationTreeData | undefined = undefined;
    publicationPageListData: IVanillaReaderSyntheticPageListData | undefined;

    isReaderViewNavigating: boolean = false;
    isReaderViewTransitioning: boolean = false;
    isReaderViewIsInPanZoomMode: boolean | undefined;
    mediaPlayerIsInRangePlaybackMode: boolean = false;
    mediaPlayerIsPausedInRange: boolean = false;

    mediaPlayerEscapabilityContext: IVanillaReaderEscapableContentBlockDataContext[] = [];
    navigationHistoryData: IVanillaReaderContentPositionData[] = [];
    activeUiOptionsData: IVanillaReaderUiOptionsData;
    activeSelection: { locatorData: ISimpleLocatorData | null, selector: string | undefined; isRange: boolean, selectionText: string } | undefined;
    activeTransformData: IVanillaReaderTransformData | undefined;
    visiblePageClientRects: IRect[] | undefined;
    latestReaderViewPointerDownEventCoords: ICoordinates | undefined;
    latestReaderViewPointerDownEventButton: number | undefined;
    latestReaderViewPointerDownEventTimestamp: number | undefined;
    latestReaderViewPointerUpEventCoords: ICoordinates | undefined;
    latestReaderViewPointerUpEventTimestamp: number | undefined;
    latestContentRangeData: IVanillaReaderVisibleRangeData | undefined;
    latestSyncMediaPlaybackStateData: IVanillaSyncMediaPlaybackStateData | undefined;
    latestTimelinePosition: number | undefined = undefined;
    latestReadingPositionData: IVanillaReaderContentPositionData | undefined = undefined;
    latestCaretLocatorData: ISimpleLocatorData | undefined = undefined;
    visibleContentRectData: IVisibleContentRectData[] | undefined;

    /**
     *
     * UI state fields. These affect UI element behaviour etc. and do not directly reflect the `VanillaReader` state.
     *
     * These fields are accessible to all `VanillaReaderUi*Controller` classes.
     *
     * */

    mediaPlayerShouldStartPlaybackWhenReady: boolean = false;
    isInReadingRulerMode: boolean = false;
    sendRefreshIntentAfterDialogClosed: boolean = false;
    showMenuOnReaderViewClick: boolean = true;
    previousUiOptionsData: IVanillaReaderUiOptionsData | undefined;
    latestSelectedSearchResultLocator: string | undefined = undefined;
    activeDialogTitle: string | undefined;

    selectionTimeoutHandle: number | undefined;
    screenWakeLockSentinel: WakeLockSentinel | undefined;
    readerViewPointerUpTimeoutHandle: number | undefined;
    readerViewPointerHoverTimeoutHandle: number | undefined;

    private _ownerDocument: Document;

    private _style = `
        <style>
            :root {
                font-size: 16px;
                
                /*
                * The color variables below define the Vanilla Readers "theming system". These vars are used by all
                * UI components, such as the menu and the dialogs, as color values.
                * Check out the setUiTheme method to see how they are used in JavaScript to change app theme.
                */
                
                --vanilla-reader__color__reader__background-light: ${this._initialPalette.backgroundLight};
                --vanilla-reader__color__reader__background-dark: ${this._initialPalette.backgroundDark};
                --vanilla-reader__color__reader__foreground-light: ${this._initialPalette.foregroundLight};
                --vanilla-reader__color__reader__foreground-dark: ${this._initialPalette.foregroundDark};

                --vanilla-reader__color__ui__background-light: ${this._initialPalette.uiBackgroundLight};
                --vanilla-reader__color__ui__background-dark: ${this._initialPalette.uiBackgroundDark};
                --vanilla-reader__color__ui__foreground-light: ${this._initialPalette.uiForegroundLight};
                --vanilla-reader__color__ui__foreground-dark: ${this._initialPalette.uiForegroundDark};
                --vanilla-reader__color__ui__outline-light: ${this._initialPalette.uiOutlineLight};
                --vanilla-reader__color__ui__outline-dark: ${this._initialPalette.uiOutlineDark};
                --vanilla-reader__color__ui__accent: ${this._initialPalette.accent};                     
            }
                    
            hr {            
                min-width: 100%;
                height: 1px;
                border: 0;
                border-top: 1px solid var(--vanilla-reader__color__ui__outline-dark);                
            }
            
            li {
                cursor: pointer;
                margin-top: 1em;
                margin-bottom: 1em;
                min-height: 40px;
            }
            
            li a {
                display: block;
            }
            
            label, input, select {
                display: block;
                margin: 1em;
                margin-left: 0;
                margin-right: 0;
            }
            
            input, select {
                font-size: 16px;
                border-radius: 12px;
                padding: 1em;
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);                               
            }
            
            select {
                min-width: 12em;
                max-width: min(100%,24em);
            }
            
            input[type=checkbox] {                
                height: 40px;  
                width: 40px;    
                border-radius: 12px;
                /* remove saturation in order to better match with color themes */
                mix-blend-mode: luminosity;   
            }

            input[type=range] {                
                /* remove saturation in order to better match with color themes */
                /* mix-blend-mode: luminosity;   */
            }
            
            textarea {
                font-size: 16px;
            }
            
            button, input[type=button], input[type=submit] {
                font-family: Material Icons Round;
                display: flex;
                flex-direction: row;
                align-items: center;
                align-self: center;
                justify-content: space-around;   
                margin: 0.5em;                               
                cursor: pointer;
                user-select: none;
                border: 0;
                border-radius: 12px;                
                min-width: 48px;
                height: 48px;
                border: 1px solid var(--vanilla-reader__color__ui__outline-dark);
                background-color: var(--vanilla-reader__color__ui__background-light);
                color: var(--vanilla-reader__color__ui__foreground-dark);
            }
            
            button[disabled] {
                opacity: 0.5;
            }
                                    
            #vanilla-reader {                             
                background-color: var(--vanilla-reader__color__reader__background-dark);
                color: var(--vanilla-reader__color__reader__foreground-dark);
                width: 100%;
                height: 100%;
                max-height: 100%;
                display: flex;
                flex-direction: column;        
            }      
            
            #vanilla-reader__reader-view {
                width: 100vw;
                height: 100vh;
                max-height: 100vh;
                position: relative;
                display: flex;
                flex-direction: column;                
            }
            
            #vanilla-reader__reader-view__loader {
                width: auto;
                height: auto;
                text-align: center;
                vertical-align: center;
                animation-name: spin;
                animation-duration: 5000ms;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
            }

            .vanilla-reader__loader {
                position: relative;
                height: 42px;
                width: 42px;
            }

            .vanilla-reader__loader__spinner {
                position: absolute;
                display: inline-block;
                background-color: transparent;
                border-right: 1px solid #69a742;
                border-radius: 50% 50%;
                animation: spin 3s infinite;
                transform: rotate(30deg);
                opacity: .7;
                width: 100%;
                height: 100%;
            }
            .vanilla-reader__loader__logo {
                position: absolute;
                background-image: url(data:image/svg+xml;base64,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);
                background-position: center;
                background-repeat: no-repeat;
                background-size: contain;
                width: 70%;
                height: 70%;
                top: 15%;
                left: 15%;
            }
            
            #vanilla-reader__fab-container {                
                position: fixed;
                z-index: 2;
                display: flex;
                flex-direction: column;
                right: 24px;
                bottom: 24px;
                width: 48px;                                
                cursor: pointer;
                transition: margin-bottom ease-in-out 0.1s;
            }
            
            #vanilla-reader__button-container {
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                z-index: 2;
                align-items: center;
                width: 100%;
                align-self: center;
                background: var(--vanilla-reader__color__ui__background-dark);
            }
            
            #vanilla-reader__slider-progression-container {
                display: flex;
                justify-content: center;
            }
            
            .vanilla-reader__fab {
                display: none;
                pointer-events: none;
                opacity: 0;                
                transition: opacity ease-in-out 0.2s;            
                cursor: pointer;
                z-index: 1;
                box-shadow: 0 4px 8px rgba(0,0,0,0.2);
                background-color: var(--vanilla-reader__color__ui__background-dark);
                color: var(--vanilla-reader__color__ui__foreground-light);
                border-radius: 12px;
                width: 48px;
                height: 48px;
                font-size: x-large;
            }
            
            .vanilla-reader__fab__icon {
                pointer-events: none;
            }
            
            .vanilla-reader__bookmark-container {
                width: 48px;
                height: 48px;
                cursor: pointer;
            }
            
            .vanilla-reader__bookmark-container::before {
                content: "bookmark";
                font-family: "Material Icons Round"            
            }
            
            .colibrio-reader-view-annotation-layer--right-spread .vanilla-reader__bookmark-container {
                right: 0;
                left: unset!important;
            }
            
            .colibrio-custom-page-content {
                pointer-events: none;
            }
            
            .vanilla-reader-icon {
                display: inline-block;
                font-family: Material Icons Round;
                font-weight: normal;
                color: var(--vanilla-reader__color__ui__foreground-dark);
                font-size: 24px;
                margin-right: 0.5em;
                vertical-align: middle;
            }
            
            .vanilla-reader__card {
                padding: 1em;
                border-radius: 12px;                
                box-shadow: 0px 2px 8px rgb(0 0 0 / 17%);
            }

        </style>`;

    private _template = `
        <div id="vanilla-reader">
            <div id="vanilla-reader__reader-view" tabindex="0"></div>     
            <div role="presentation" id="vanilla-reader__slider-progression-container" tabindex="0"></div>       
            <div role="presentation" id="vanilla-reader__button-container" tabindex="0"></div>                           
            <div role="presentation" id="vanilla-reader__fab-container" tabindex="0"></div>                           
        </div>`;

    constructor(
        private _rootElement: HTMLElement,
        vanillaBookshelf: VanillaReaderBookshelf,
        vanillaReaderOptionsDataStore: IVanillaReaderOptionsDataStore,
        useDeviceStorage: boolean = false,
        private _initialPalette: IVanillaReaderUiColorTheme
    ) {
        this.vanillaReaderOptionsDataStore = vanillaReaderOptionsDataStore;
        this.vanillaBookshelf = vanillaBookshelf;

        this.useDeviceStorage = useDeviceStorage;

        this.isMobileScreenSize = window.matchMedia('only screen and (max-width: 480px)').matches;

        // Get a deep clone of the default UI options
        const defaultUiOptionsDataString = JSON.stringify(VanillaReaderAppUiDefaults.options);
        this.activeUiOptionsData = JSON.parse(defaultUiOptionsDataString);

        this._ownerDocument = _rootElement.ownerDocument!;
        this._rootElement.innerHTML = this._template;
        this._rootElement.insertAdjacentHTML('afterbegin', this._style);
        this.vanillaReaderUIElement = this._ownerDocument.getElementById('vanilla-reader')!;
        this.vanillaReaderViewElement = this._ownerDocument.getElementById('vanilla-reader__reader-view')!;
        this.vanillaReaderButtonContainerElement = this._ownerDocument.getElementById('vanilla-reader__button-container')!;
        this.vanillaReaderFabContainerElement = this._ownerDocument.getElementById('vanilla-reader__fab-container')!;
        this.vanillaReaderSliderContainerElement = this._ownerDocument.getElementById('vanilla-reader__slider-progression-container')!;

        // This component uses output elements to display toast messages.
        this.toaster = new VanillaReaderUiToaster(this.vanillaReaderUIElement);
        this.menuBottom = new VanillaReaderUiMenu(this.vanillaReaderUIElement, 'beforeend', this);
        this.menuSide = new VanillaReaderUiSideMenu(this.vanillaReaderUIElement, 'beforeend');
        this.menuMediaPlayer = new VanillaReaderUiMenuMediaPlayer(this.menuBottom.getMediaPlayerContainerElement());
        this.dialogHighlight = new VanillaReaderUiDialogHighlight(this.vanillaReaderUIElement);
        this.dialogHighlights = new VanillaReaderUiDialogHighlights(this.vanillaReaderUIElement);
        this.dialogSettings = new VanillaReaderUiDialogSettings(this.vanillaReaderUIElement);
        this.dialogContents = new VanillaReaderUiDialogContents(this.vanillaReaderUIElement);
        this.dialogBookmarks = new VanillaReaderUiDialogBookmarks(this.vanillaReaderUIElement);
        this.dialogSearch = new VanillaReaderUiDialogSearch(this.vanillaReaderUIElement);
        this.dialogImageViewer = new VanillaReaderUiDialogImageViewer(this.vanillaReaderUIElement);
        this.dialogHelp = new VanillaReaderUiDialogHelp(this.vanillaReaderUIElement);
        this.dialogOpenFile = new VanillaReaderUiDialogOpenFile(this.vanillaReaderUIElement, 'afterbegin', this.useDeviceStorage, []);
        this.masterplanStart = new MasterPlanUiStart(this.vanillaReaderUIElement, 'afterbegin');
        this.dialogFootnote = new VanillaReaderUiDialogFootnote(this.vanillaReaderUIElement);
        this.dialogUiActions = new VanillaReaderUiDialogActions(this.vanillaReaderUIElement);
        this.readingRuler = new VanillaReaderUiReadingRuler(this.vanillaReaderUIElement, 'beforeend');
        this.dialogLandmarks = new VanillaReaderUiDialogPublicationLandmarks(this.vanillaReaderUIElement);
        this.dialogNavigationHistory = new VanillaReaderUiDialogNavigationHistory(this.vanillaReaderUIElement);

        this.fabMediaPlayer = new VanillaReaderUiFabMediaPlayer(this.vanillaReaderFabContainerElement);
        this.fabHighlight = new VanillaReaderUiFabHighlight(this.vanillaReaderFabContainerElement);
        this.fabSpeakText = new VanillaReaderUiFabSpeakText(this.vanillaReaderFabContainerElement);
        this.panZoomTool = new VanillaReaderUiPanZoomTool(this.vanillaReaderFabContainerElement);

        this.labelPageNumber = new VanillaReaderUiLabelPageNumber(this.vanillaReaderSliderContainerElement, 'beforeend')
        this.buttonMenu = new VanillaReaderUiButtonMenu(this.vanillaReaderButtonContainerElement, 'beforeend');
        //this.buttonPrevious = new VanillaReaderUiButtonPrevious(this.vanillaReaderButtonContainerElement, 'beforeend');
        this.menuProgressionSlider = new VanillaReaderUiSliderProgression(this.vanillaReaderButtonContainerElement, 'beforeend');
        this.functionButtons = new VanillaReaderUiFunctionButtons(this.vanillaReaderButtonContainerElement, 'beforeend', this);
        //this.buttonNext = new VanillaReaderUiButtonNext(this.vanillaReaderButtonContainerElement, 'beforeend');

        if(_initialPalette) {
            this.setUiColorTheme(_initialPalette)
        }

        // In order to get some code separation in VanillaReaderUI class, UI controller code is split up into mixin classes.
        this._applyUiControllerMixins([
            VanillaReaderUiKeyboardShortcutController,
            VanillaReaderUiMenuMediaPlayerController,
            VanillaReaderUiMenuController,
            VanillaReaderUiSideMenuController,
            VanillaReaderUiSliderProgressionController,
            VanillaReaderUiMediaSessionsController,
            VanillaReaderUiDialogController,
            VanillaReaderUiDialogUiActionsController,
            VanillaReaderUiDialogHighlightController,
            VanillaReaderUiDialogHighlightsController,
            VanillaReaderUiDialogBookmarksController,
            VanillaReaderUiDialogOpenFileController,
            MasterPlanUIStartController,
            VanillaReaderUiDialogSettingsController,
            VanillaReaderUiDialogFootnoteController,
            VanillaReaderUiDialogImageViewerController,
            VanillaReaderUiDialogSearchController,
            VanillaReaderUiDialogContentsController,
            VanillaReaderUiDialogNavigationHistoryController,
            VanillaReaderUiVanillaReaderEventController,
            VanillaReaderUiFabHighlightController,
            VanillaReaderUiFabMediaPlayerController,
            VanillaReaderUiButtonMenuController,
            //VanillaReaderUiButtonNextController,
            //VanillaReaderUiButtonPreviousController,
            VanillaReaderUiPanZoomToolController,
            VanillaReaderUiReadingRulerController,
            VanillaReaderUiLabelPageNumberController,
            VanillaReaderUiDialogPublicationLandmarksController,
            VanillaReaderUiFabSpeakTextController,
            VanillaReaderUiFunctionButtonsController,
        ]);

        window.addEventListener('resize', this._uiEvent_windowResize.bind(this));
        window.addEventListener('keyup', this._uiEvent_uiKeyUp.bind(this));

        this.vanillaReaderAPI.onAppUiOptionsReset(this._uiEvent_uiOptionsReset);

        this._setUpMediaSessionActionHandlers();

        this._addVanillaReaderAPIEventListeners();

        this._setup().catch(console.warn);
    }

    get vanillaReaderAPI(): VanillaReaderAPI {
        if(!VanillaReaderAPI.instance) {
            throw new Error('VanillaReaderUI.vanillaReaderAPI: The API has not been instantiated.');
        }
        return VanillaReaderAPI.instance;
    }

    get isInAccessibilityMode(): boolean {
        return this.activeUiOptionsData.useAccessibilityMode || false;
    }

    get isInDarkMode(): boolean {
        return this.vanillaReaderAPI.isInDarkMode;
    }

    get useReducedMotion(): boolean {
        return this.activeUiOptionsData.useReducedMotion || VanillaReaderAppUiDefaults.options.useReducedMotion!;
    }

    clearContentSelection(): void {
        this.vanillaReaderAPI?.clearContentSelection();
        this.toaster.toast('Text selection cleared.', true).catch(console.warn);
    }

    destroy(): void {
        window.removeEventListener('resize', this._uiEvent_windowResize.bind(this));
    }

    playAmbientMedia(){
        this.vanillaReaderAPI?.playAmbientMedia();
    }

    stopAmbientMedia(){
        this.vanillaReaderAPI?.stopAmbientMedia();
    }


    setReadingPositionData(readingPositionData: IVanillaReaderContentPositionData): void {
        this.latestReadingPositionData = readingPositionData;
    }

    setReaderViewAsNotImportantForAccessibility(): void {
        this.vanillaReaderViewElement.ariaHidden = 'true';

        this.vanillaReaderFabContainerElement.querySelectorAll('button').forEach((buttonElement)=>{
            buttonElement.setAttribute('aria-hidden', 'true');
        });

        this.vanillaReaderButtonContainerElement?.querySelectorAll('button').forEach((buttonElement)=>{
            buttonElement.setAttribute('aria-hidden', 'true');
        });

    }

    setReaderViewAsImportantForAccessibility(): void {
        this.vanillaReaderViewElement.removeAttribute('aria-hidden');

        this.vanillaReaderFabContainerElement.querySelectorAll('button').forEach((buttonElement)=>{
            buttonElement.removeAttribute('aria-hidden');
        });

        this.vanillaReaderButtonContainerElement?.querySelectorAll('button').forEach((buttonElement)=>{
            buttonElement.removeAttribute('aria-hidden');
        });

    }

    /*
    *
    * This method serializes the app settings and returns them to the caller.
    * This method is called in index.ts when the app saves the current state.
    *
    * */
    serializeToUiOptionsData(): IVanillaReaderUiOptionsData {
        let settingsState = this.dialogSettings?.serializeSettingsState();
        settingsState.showNarrationControls = this.menuMediaPlayer.isOpen();
        settingsState.showReadingRuler = this.readingRuler.isVisible;
        return settingsState;
    }

    /*
    *
    * setUiColorTheme takes in a IVanillaReaderColorPalette object and applies it by updating the CSS variables defined in the
    * VanillaReaderUI stylesheet.
    * Note that these colors are specific to the UI, the publication style is updated in the `setPublicationStyleOptions`
    * method.
    *
    * */
    setUiColorTheme(palette: IVanillaReaderUiColorTheme | undefined): void {
        if(palette) {
            this.vanillaReaderAPI?.setAppMainColorTheme(palette);
        }
        // Make the overlay match the theme
        this.readingRuler.setOptions({
            overlayBackgroundColor: palette?.backgroundDark || '#000'
        });
    }

    /**
     *
     * This is a utility method for screen reader users. If the user get lost in the interface this method will close
     * all modals and set focus back on the reading position.
     *
     * */
    closeAllDialogsAndFocusOnReadingPosition(): void {
        this.dialogSettings.close(true);
        this.dialogContents.close(true);
        this.dialogSearch.close(true);
        this.dialogHighlights.close(true);
        this.dialogBookmarks.close(true);
        this.dialogHighlight.close(true);
        this.dialogImageViewer.close(true);
        this.dialogHelp.close(true);
        this.dialogFootnote.close(true);
        this.dialogUiActions.close(true, false);
        // `menuBottom.hide` also focuses on reading position
        this.menuBottom.hide(this.useReducedMotion, true);
        this.menuSide.hide(this.useReducedMotion, true);
    }

    /**
     *
     * This is a utility method for screen reader users. It alerts the current reading position using a toast.
     *
     * */
    async toastReadingPosition(): Promise<string | void> {
        const announcement = await this._composeReadingPositionAnnouncement();
        this.toaster.toast(announcement || 'Unknown reading position', true, 5000).catch(console.warn);
    }

    async toastHrefTargetPositionInfo(href: string, baseDocumentLocator?: string): Promise<void> {

        let documentLocator = baseDocumentLocator || this.latestReadingPositionData?.locator;
        if (!documentLocator) {
            console.warn('VanillaReaderUI.announceHrefTargetPositionInfo(), Unable to get the locator for the current reading position.');
            return;
        }

        if(href.startsWith('http')) {
            this.toaster.toast(`Link opens URL "${href}"`, true).catch();
        } else {
            let contentPositionData = await this.vanillaReaderAPI?.fetchContentPositionDataForHref(href, documentLocator);
            if(contentPositionData) {
                let text =  contentPositionData?.navItemData ?
                    `Link opens book section "${contentPositionData.navItemData[0].title}"\nAt location ${
                        (contentPositionData.syntheticPageData && contentPositionData.syntheticPageData.length > 0)
                            ? contentPositionData.syntheticPageData[0].label : '?'
                    }` : '';
                if(text) {
                    this.toaster.toast(text, true).catch();
                }
            }
        }
    }

    // This method tries to find a `IVanillaReaderLandmarkData` object based on an HTML element's id attribute.
    getFootnoteLandmarkByElementId(id: string): VanillaReaderLandmark | undefined {
        return this.publicationFootnoteLandmarks?.find((footnote: VanillaReaderLandmark) => {
            return footnote.attributes.find((attributeData) => {
                return attributeData.localName === 'id' && attributeData.value === id;
            });
        });
    }

    /**
     *
     * This is a utility method for screen reader users. It navigates to the next heading in the publication contents,
     * similar to what the screen reader offers when browsing the web.
     *
     * */
    async navigateToNextHeading(): Promise<void> {
        let nextHeadingLandmark: VanillaReaderLandmark | undefined = undefined;
        let latestTimelinePosition = this.latestTimelinePosition;
        let headings = this.publicationHeadingLandmarks;
        if (headings && latestTimelinePosition) {
            for (let i = 0; i < headings.length; i++) {
                let heading: VanillaReaderLandmark = headings[i];
                let timelinePosition = await heading.fetchTimelinePosition();

                if (timelinePosition && timelinePosition > latestTimelinePosition) {
                    nextHeadingLandmark = heading;
                    break;
                }
            }
        }

        if (nextHeadingLandmark && nextHeadingLandmark.locatorUrl) {
            this.navigateTo(nextHeadingLandmark.locatorUrl, true);
        } else {
            this.toaster.toast('No next heading').catch(console.warn);
        }

    }

    /**
     *
     * This is a utility method for screen reader users. It navigates to the previous heading in the publication contents,
     * similar to what the screen reader offers when browsing the web.
     *
     * */
    async navigateToPreviousHeading(): Promise<void> {
        let previousHeadingLandmark: VanillaReaderLandmark | undefined = undefined;
        let latestTimelinePosition = this.latestTimelinePosition;
        let headings = this.publicationHeadingLandmarks;

        if (headings && latestTimelinePosition) {
            for (let i = headings.length - 1; i >= 0; i--) {
                let heading: VanillaReaderLandmark = headings[i];
                let timelinePosition = await heading.fetchTimelinePosition();
                if (timelinePosition && timelinePosition < latestTimelinePosition) {
                    previousHeadingLandmark = heading;
                    break;
                }
            }
        }

        if (previousHeadingLandmark && previousHeadingLandmark.locatorUrl) {
            this.navigateTo(previousHeadingLandmark.locatorUrl, true);
        } else {
            this.toaster.toast('No previous heading').catch(console.warn);
        }
    }

    /**
     *
     * `AccessibilityMode` is a "preset" configuration of sorts that is optimised for screen readers.
     * It turns on the `SingleDocumentScrollRenderer`, enlarges the fonts size and turns off animations.
     *
     **/
    enterAccessibilityMode(): void {

        this.previousUiOptionsData = this.dialogSettings.serializeSettingsState();

        // Just in case this was called from an action and not the GUI.
        this.dialogSettings.setUseAccessibilityModeOption(true);

        let pageMargin = this.isMobileScreenSize ? 6 : 18;

        const currentUiOptions = this.activeUiOptionsData;
        currentUiOptions.useAccessibilityMode = true;
        currentUiOptions.publicationStyleOptions  = currentUiOptions.publicationStyleOptions ?? {};
        currentUiOptions.publicationStyleOptions.fontSizeScaleFactor = 2.5;
        currentUiOptions.publicationStyleOptions.lineHeightScaleFactor = 1.2;
        currentUiOptions.publicationStyleOptions.pageMargins = {
                left: {
                    value: pageMargin,
                    unit: LengthUnit.PERCENT,
                },
                right: {
                    value: pageMargin,
                    unit: LengthUnit.PERCENT,
                },
                top: {
                    unit: LengthUnit.PERCENT,
                    value: VanillaReaderAppUiDefaults.options.publicationStyleOptions!.pageMargins!.top.value,
                },
                bottom: {
                    unit: LengthUnit.PERCENT,
                    value: VanillaReaderAppUiDefaults.options.publicationStyleOptions!.pageMargins!.bottom.value,
                },
        };

        this.vanillaReaderAPI.setAppUiOptions(currentUiOptions);
        this.setUseReducedMotion(true);

        this.setPublicationOptions({
            customPublicationCss: {
                injectionPointStart: [
                    ':focus-visible {outline: 2px dotted #ffb55a;}',
                ],
            },
        })

        this.setPublicationRenderer(VanillaReaderRendererNames.SCROLL, true);

        // We need to manually re-focus the AT on the current reading position after the renderer has changed.
        this.vanillaReaderAPI.onRendererChanged(()=>{
            this.focusOnReadingPosition();
        },true);

        this.menuMediaPlayer.open();

        this.toaster.toast('UI is in accessibility mode.', true).catch(console.warn);
    }

    exitAccessibilityMode(): void {

        // Just in case this was called from an action and not the GUI.
        this.dialogSettings.setUseAccessibilityModeOption(false);

        this.setPublicationOptions({
            customPublicationCss: {
                injectionPointStart: [
                    ':focus-visible {outline: initial;}',
                ],
            },
        });

        if(this.previousUiOptionsData && !ObjectUtils.deepEqual(this.previousUiOptionsData, this.activeUiOptionsData)) {
            this.vanillaReaderAPI.setAppUiOptions(this.previousUiOptionsData);
        } else {
            this.vanillaReaderAPI.resetAppUiOptions();
        }

        // We need to manually re-focus the AT on the current reading position after the renderer has changed.
        this.vanillaReaderAPI.onRendererChanged(()=>{
            this.focusOnReadingPosition();
        }, true);

        this.toaster.toast('UI is not accessibility mode.', true).catch(console.warn);
    }

    setPublicationRenderer(rendererTypeName: VanillaReaderRendererNames, ignoreAspectRatio?: boolean): void {
        this.dialogSettings.setSelectedRendererOption(rendererTypeName);
        this.vanillaReaderAPI?.changeRenderer(rendererTypeName, ignoreAspectRatio || this.dialogSettings.activeAspectRatioOption);
    }

    setPublicationStyleOptions(publicationStyleOptions: IVanillaReaderPublicationStyleOptions): void {
        this.vanillaReaderAPI?.setPublicationStyleOptions(publicationStyleOptions);
    }
    setPublicationOptions(publicationOptions: IEpubReaderPublicationOptions | IPdfReaderPublicationOptions | IWpAudiobookReaderPublicationOptions): void {
        this.vanillaReaderAPI?.setPublicationOptions(publicationOptions)
    }

    setUseReducedMotion(useReducedMotion: boolean): void {
        this.dialogSettings.setUseReducedMotionOption(useReducedMotion);
        this.vanillaReaderAPI?.useReducedMotion(useReducedMotion);
    }

    setIgnoreAspectRatio(ignoreAspectRatio: boolean): void {
        this.dialogSettings.setRendererAspectRatioOption(ignoreAspectRatio);
        this.vanillaReaderAPI?.ignorePublicationAspectRatio(ignoreAspectRatio);
    }

    setScrollOverflowingTables(scrollOverflowingTables: boolean): void {
        this.vanillaReaderAPI?.scrollOverflowingTables(scrollOverflowingTables);
    };

    highlightVisibleRange(showEditDialog: boolean = true): void {
        if (this.latestContentRangeData && this.latestContentRangeData.locator) {
            let highlight: IVanillaReaderHighlightData = {
                locator: this.latestContentRangeData.locator.toUrl().toString(),
                color: VanillaReaderAppUiDefaults.highlightColorValues.yellow,
                selectionText: this.latestContentRangeData.visibleTextContent || '',
                comment: '',
            };
            this.dialogHighlight?.setState(highlight, true);

            // Should we show the highlight dialog so that the user can edit it directly, or should we just save it?
            if (showEditDialog) {
                this.dialogHighlight?.show();
            } else {
                this._onDialogHighlightAdd(highlight);
            }
        }
    }

    highlightReadingPosition(showEditDialog: boolean = true): void {
        if (this.latestReadingPositionData && this.latestReadingPositionData.contentBlockData && this.latestReadingPositionData.contentBlockData.locator) {

            let highlight: IVanillaReaderHighlightData = {
                locator: this.latestReadingPositionData.contentBlockData.locator.toString(),
                color: VanillaReaderAppUiDefaults.highlightColorValues.yellow,
                selectionText: this.latestReadingPositionData.contentBlockData.textContent,
                comment: '',
            };

            // Should we show the highlight dialog so that the user can edit it directly, or should we just save it?
            if (showEditDialog) {
                this.dialogHighlight?.setState(highlight, true);
                this.dialogHighlight?.show();
            } else {
                this._onDialogHighlightAdd(highlight);
            }
        }
    }

    /**
     * This method is a quirkfix to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to the VanillaReader, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the VanillaReaderUI using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */
    async highlightClipboardContents(): Promise<void> {
        let clipboardContents = await navigator.clipboard.readText();

        if (!clipboardContents) {
            this.toaster.toast('Unable to create highlight. The clipboard is empty.', true).catch(console.warn);
            return;
        }

        if (this.latestReadingPositionData?.documentIndex) {
            this.vanillaReaderAPI?.highlightTextLocation(
                clipboardContents,
                this.latestReadingPositionData.documentIndex,
                {
                locator: '',
                    color: VanillaReaderAppUiDefaults.highlightColorValues.yellow,
                    selectionText: clipboardContents,
                    comment: '',
            });
        }
    }

    /**
     * This method is a "quirkfix" to let Screen Reader users (primarily NVDA and JAWS) highlight text based on the contents
     * of their clipboard.
     *
     * The reason that we need this is because of the Screen Readers inability to scroll the document as it moves through
     * the document contents. This is a problem for us since we use the visible range as a means to know where the user
     * is reading, so without a change in the visible range we can't can add a correct highlight or bookmark.
     *
     * The way that the Screen Reader user will use this feature is as follows:
     *
     * 1. The user selects and copies the text that represents the location they want highlight or bookmark.
     * 2. The user uses some method to trigger a UI call to the VanillaReader, sending along the text that is currently
     * in the user's clipboard as well as the document index in the publication spine.
     * 3. This method uses the publication search to grab the first occurrence of the string in the specified document.
     * 4. The result is communicated back to the VanillaReaderUI using the `HIGHLIGHT_ADDED` / `BOOKMARK_ADDED` or
     * `HIGHLIGHT_TEXTLOCATION_FAILED` / `BOOKMARK_TEXTLOCATION_FAILED` events.
     *
     * */
    async bookmarkClipboardContents(): Promise<void> {
        let clipboardContents = await navigator.clipboard.readText();

        if (!clipboardContents) {
            this.toaster.toast('Unable to create bookmark. The clipboard is empty.', true).catch(console.warn);
            return;
        }

        if (this.latestReadingPositionData?.documentIndex && clipboardContents) {
            this.vanillaReaderAPI?.bookmarkTextLocation(clipboardContents, this.latestReadingPositionData.documentIndex);
        }
    }

    bookmarkReadingPosition(): void {
        this.vanillaReaderAPI?.bookmarkReadingPosition();
    }

    focusOnReadingPosition(): void {
        this.vanillaReaderAPI?.focusOnReadingPosition();
    }

    navigatePrevious(focusNearContentLocation: boolean = true): void {
        this.vanillaReaderAPI?.navigate({navigationType: VanillaReaderNavigationType.PREVIOUS, focusNearContentLocation});
    }

    navigateNext(focusNearContentLocation: boolean = true): void {
        this.vanillaReaderAPI?.navigate({navigationType: VanillaReaderNavigationType.NEXT, focusNearContentLocation});
    }

    navigateTo(locator: string, focusNearContentLocation: boolean = true): void {
        if (this.latestReadingPositionData) {
            this._updateNavigationHistory(this.latestReadingPositionData);
        }
        this.vanillaReaderAPI?.navigate({
            navigationType: VanillaReaderNavigationType.GOTO,
            locator,
            focusNearContentLocation: focusNearContentLocation,
        });
    }

    navigateToTimelinePosition(position: number): void {
        if (this.latestReadingPositionData) {
            this._updateNavigationHistory(this.latestReadingPositionData);
        }
        this.vanillaReaderAPI?.navigate({
            navigationType: VanillaReaderNavigationType.TIMELINEPOSITION, position
        });
    }

    refreshReaderView(force: boolean = false): void {
        this.vanillaReaderAPI?.refreshReaderView(force);
    }

    searchPublication(searchTerm: string, resultSetMaxSize?: number, documentsToSearch?: number[]): void {
        this.vanillaReaderAPI?.searchPublication(
            searchTerm,
            resultSetMaxSize || 50,
            documentsToSearch,
        )
    }

    showLandmarksDialog(): void {
        if(!this.dialogLandmarks.hasBeenPopulated) {
            let landmarks = [
                ...(this.publicationHeadingLandmarks ||[]),
                ...(this.publicationTableLandmarks ||[]),
                ...(this.publicationListLandmarks ||[]),
                ...(this.publicationFigureLandmarks ||[]),
                ...(this.publicationFootnoteLandmarks ||[]),
            ]
            this.dialogLandmarks.populate(landmarks)
        }
        this.dialogLandmarks.show();
    }

    /**
     * This method shows a simple browser prompt that lets the user input a location number to navigate to.
     * It's very basic and to the point UI component, so I did not bother making a class etc. for it.
     *
     * Note that there are caveats with using `window.prompt` as it blocks the Main thread until the prompt is closed.
     * This can cause the app to behave incorrectly as event handlers and setTimeout calls will be not be called
     * while the prompt is active.
     *
     * The reason I chose the native prompt for this is that it is, to my knowledge, the only way for
     * us to guarantee that the screen reader will return to its original position within the page contents.
     *
     * The native Dialog element is still not reliable enough to be used from my research.
     */
    showGoToPagePrompt(): void {
        let pageList = this.menuProgressionSlider.syntheticPages;

        if (!pageList) {
            this.toaster.toast('This publication has no defined locations', true).catch(console.warn);
            return;
        }

        // If the SyncMedia is playing we should pause it since the prompt will block the main thread and so the narration
        // gets out of sync with reader view.
        if (this.menuMediaPlayer.stateIsPlaying) {
            this._onMenuMediaPlayerPauseIntent();
        }

        let currentPageItem: IVanillaReaderSyntheticPageData | undefined = this.menuProgressionSlider.activeSyntheticPage

        let pageInputValue = window.prompt(`Go to page\n\nInput the location number to go to (1-${pageList.length})`, currentPageItem?.label);

        if (!pageInputValue) {
            return;
        }

        let pageItemToGoTo = pageList?.find((item: IVanillaReaderSyntheticPageData) => {
            return item.label === pageInputValue;
        });

        if (!pageItemToGoTo || !pageItemToGoTo.range) {
            this.toaster.toast('This location number does not exist in the publication.', true).catch(console.warn);
            return;
        } else {
            this.navigateToTimelinePosition(pageItemToGoTo.range.start);
        }
    }

    closePublicationAndShowFileOpenDialog(): void {
        this.vanillaReaderAPI?.closePublication();
    }

    openMediaPlayer(startPlaybackWhenReady: boolean): void {
        this.menuMediaPlayer.open();
        if (startPlaybackWhenReady) {
            this.mediaPlayerShouldStartPlaybackWhenReady = true;
        }
    }

    startMediaPlayer(locator?: string): void {
        this.startPlayback(locator);
    }

    closeMediaPlayer(): void {
        if (this.menuMediaPlayer.isOpen()) {
            this.pausePlayback();
            this.menuMediaPlayer.close();
        }
    }

    speakText(text:string): void {
        this.webSpeechPlayerForTextSelections?.addUtterance({
            text: {
                lang: this.initialPublicationData?.language || 'en',
                value: text,
                dir: this.initialPublicationData?.isRtl ? TextDirection.RTL : TextDirection.LTR,
            },
            id: Date.now(),
            charOffset: 0,
            nodeData: null,
        });

        this.webSpeechPlayerForTextSelections?.play();
    }

    speakActiveSelection(): void {
        if(this.fabSpeakText.stateIsSpeaking) {
            window.speechSynthesis.cancel();
            this.fabSpeakText.stateIsSpeaking = false;
            return;
        }

        this.speakText(this.activeSelection?.selectionText || '');

        this.fabSpeakText.stateIsSpeaking = true;

    }

    speakTimelineRange(startIndex: number, endIndex: number, options?: ISyncMediaPlaybackRangeOptions): void {
        this.vanillaReaderAPI?.playTimelineRange({
                start : {
                    segmentIndex: startIndex,
                    offsetWithinSegmentMs: 0,
                },
                end: {
                    segmentIndex: endIndex,
                    offsetWithinSegmentMs: 0,
                }
            },
            options);
    }

    showHighlightDialogWithActiveSelectionState(): void {
        if (!this.activeSelection || !this.activeSelection.selector) {
            this.toaster.toast('There is no text selection to highlight.', true).catch(console.warn);
            return;
        }
            let highlight: IVanillaReaderHighlightData = {
                locator: this.activeSelection.selector,
                color: VanillaReaderAppUiDefaults.highlightColorValues.yellow,
                selectionText: this.activeSelection.selectionText,
                comment: '',
            };
            this.dialogHighlight?.setState(highlight, true);
            this.dialogHighlight?.show();
    }

    activatePanZoomTool(): void {
        if(!this.panZoomTool.isActive) {
            this.panZoomTool.activate();
        }
        this.panZoomTool.enablePointerZoom();

        if(this.readingRuler.isVisible) {
            this.readingRuler.hide();
        }
    }

    deactivatePanZoomTool(): void {
        if(this.isReaderViewIsInPanZoomMode === true) {
            this.panZoomTool.deactivate();
        }
    }

    resetPanZoomTransform(): void {
        this.panZoomTool.resetZoomLevel();
    }

    zoomToLevel(zoomLevel: number, animate?: boolean): void {
        this.activatePanZoomTool();
        let relativeZoomLevel = this.activeTransformData?.transformData ? this.activeTransformData.transformData.scale * zoomLevel : zoomLevel;

        this.panZoomTool.zoomToolToLevel(relativeZoomLevel, animate);
        this.panZoomTool.enablePanning();
    }

    zoomToPublicationViewportRect(zoomRect: IRect, transformOptions: ITransformRectZoomOptions): void {
        const zoomDomRect = new DOMRect(zoomRect.x, zoomRect.y, zoomRect.width, zoomRect.height);
        this.vanillaReaderAPI?.zoomToPublicationViewportClientRect(zoomDomRect, LengthUnit.PERCENT, transformOptions);
    }

    showReadingRuler(affectReadingPosition?: boolean): void {

        affectReadingPosition = affectReadingPosition === undefined ? true : affectReadingPosition;

        if(!this.isInReadingRulerMode) {

            let paletteAsset: IVanillaReaderUiColorTheme |undefined = VanillaReaderAppAssets.ColorThemes.find(palette => palette.name === this.activeUiOptionsData?.activeUiPaletteName);

            // We persist the options state in order to be able to switch back to it if the
            // user hides the ruler.
            this.previousUiOptionsData = this.dialogSettings.serializeSettingsState();
            this.setPublicationStyleOptions({
                lineHeightScaleFactor: 1.5,
                palette: paletteAsset
            });

            // Floated elements are really tricky to handle well when the ruler uses snapping. Let's override the
            // publication CSS to not use floats.
            if(this.initialPublicationData?.format.toLowerCase().includes('epub')) {
                this.setPublicationOptions({
                    customPublicationCss: {
                        injectionPointEnd: [
                            '* {float: none !important;}'
                        ]
                    }
                } as IEpubReaderPublicationOptions);
            }

            // Change the renderer only if it is not in scroll mode.
            if(this.dialogSettings.activeRendererTypeName !== VanillaReaderRendererNames.SCROLL) {
                this.setPublicationRenderer(VanillaReaderRendererNames.SWIPE_SINGLE);
            }

            //this.menuBottom.toggleRulerButtonState(true);
            this.isInReadingRulerMode = true;

        }

        this.moveReadingRulerToReadingPosition();

        this.readingRuler.show(undefined, affectReadingPosition);
    }

    hideReadingRuler(exitReadingRulerMode?: boolean): void {

        exitReadingRulerMode = exitReadingRulerMode === undefined ? true : exitReadingRulerMode;

        if(exitReadingRulerMode) {

            // When we opened the ruler we persisted the options state in order to be able to switch back to it if the
            // user hid the ruler. So this is what we'll do.
            if(this.previousUiOptionsData) {
                if(this.previousUiOptionsData.publicationStyleOptions) {

                    if(this.isInDarkMode !== this.previousUiOptionsData.useDarkMode) {
                        // If we have changed to dark mode since the ruler was opened, we should respect this.
                        this.previousUiOptionsData.publicationStyleOptions.palette = this.dialogSettings.serializeSettingsState().publicationStyleOptions?.palette;
                    }

                    this.setPublicationStyleOptions(this.previousUiOptionsData.publicationStyleOptions);
                }

                // Change the renderer only if it is not in scroll mode.
                if(this.dialogSettings.activeRendererTypeName !== VanillaReaderRendererNames.SCROLL) {
                    this.setPublicationRenderer(this.previousUiOptionsData.activeRendererTypeName || VanillaReaderRendererNames.RESPONSIVE);
                }
            }

            // We reset the CSS floats to their initial state.
            if(this.initialPublicationData?.format.toLowerCase().includes('epub')) {
                this.setPublicationOptions({
                    customPublicationCss: {
                        injectionPointEnd: [
                            '* {float: initial;}'
                        ]
                    }
                } as IEpubReaderPublicationOptions);
            }

            //this.menuBottom.toggleRulerButtonState(false);
            this.isInReadingRulerMode = false;
        }

        this.readingRuler.hide();
    }

    moveReadingRulerToNextContentLineBox(): void {
        if (this.activeDialogTitle === undefined) {
            if(this.readingRuler?.isVisible && this.readingRuler.snapToContentLineBoxes) {
                this.readingRuler.moveToNextContentLineBox(!this.useReducedMotion);
            }
        } else {
            console.warn('VanillaReaderUI.moveReadingRulerToNextContentLineBox', 'Unable to move reading ruler as a dialog is open');
        }
    }

    moveReadingRulerToPreviousContentLineBox(): void {
        if (this.activeDialogTitle === undefined) {
            if(this.readingRuler?.isVisible && this.readingRuler.snapToContentLineBoxes) {
                this.readingRuler.moveToPreviousContentLineBox(!this.useReducedMotion);
            }
        } else {
            console.warn('VanillaReaderUI.moveReadingRulerToPreviousContentLineBox', 'Unable to move reading ruler as a dialog is open');
        }
    }

    moveReadingRulerToReadingPosition(): void {
        let rectData =  this.latestReadingPositionData && this.latestReadingPositionData.contentRects ? this.latestReadingPositionData.contentRects[0] : undefined;

        if(this.readingRuler.isVisible && rectData) {
            if(this.readingRuler.snapToContentLineBoxes) {
                this.readingRuler.moveToAndAlign(rectData.clientRect.y, rectData.clientRect.height, !this.useReducedMotion, false);
            } else {
                this.readingRuler.moveTo(rectData?.clientRect.y, !this.useReducedMotion, true, false);
            }
        }
    }

    moveReadingRulerToPosition(y: number, affectReadingPosition: boolean = true): void {
        if(this.readingRuler.isVisible) {
            this.readingRuler.moveTo(y, !this.useReducedMotion, true, affectReadingPosition);
        }
    }

    moveReadingRulerToPageTop(affectReadingPosition: boolean = true): void {
        let firstRectOnThePage =  this.visibleContentRectData ? this.visibleContentRectData[0].clientRect : undefined;
        if(firstRectOnThePage) {
            if(this.readingRuler.snapToContentLineBoxes){
                this.readingRuler.moveToAndAlign(firstRectOnThePage.y, firstRectOnThePage.height, !this.useReducedMotion, affectReadingPosition);
            } else {
                this.readingRuler.moveTo(firstRectOnThePage.y, !this.useReducedMotion, true, affectReadingPosition);
            }
        }
    }

    togglePageNumbers = () => {
        let newOptionState: boolean = !this.dialogSettings.activeShowPageNumberOption;
        this.dialogSettings.setSelectedShowPageNumberOption(newOptionState);
        this.vanillaReaderAPI?.toggleReaderViewPageMarkerVisibility(newOptionState);
    }

    showNavigationHistory(): void {
        if(!this.dialogNavigationHistory.isOpen()) {
            this.dialogNavigationHistory.show();
        }
    }

    initializeProgressionTimeline(timelineData: IVanillaReaderReadingProgressionTimelineData): void {
        this.menuProgressionSlider.initializeTimeline(timelineData, this.publicationNavigationTreeData);
    }

    initializeNavigationTree(navigationTreeData: IVanillaReaderNavigationTreeData): void {
        if (this.dialogContents && navigationTreeData) {
            this.publicationNavigationTreeData = navigationTreeData;
            this.dialogContents.populate(navigationTreeData);
            this.menuSide.populateContents(navigationTreeData);

            // Now that we have the navigation tree, we can select the correct tree item based on the initial reading
            // position.
            let latestReadingPosition: IVanillaReaderContentPositionData | undefined = this.latestReadingPositionData;
            if (latestReadingPosition && latestReadingPosition.navItemData) {
                this.dialogContents.setActiveTocItems(latestReadingPosition.navItemData);
                this.dialogContents.setActivePageItems(latestReadingPosition.navItemData);
            }

            this.menuProgressionSlider.setNavigationTreeData(navigationTreeData);

            // We can also update the progression label in the menu to show the active toc item.
            // It's just a "refresh" so we just send in the current slider value.
            this.menuProgressionSlider.updateSliderProgressionValue(this.menuProgressionSlider.value);
        }
    }

    /*
    *
    * PRIVATE METHODS
    *
    * */

    private async _setup(): Promise<void> {
        let shelfItems: VanillaReaderShelfItem[] = await this.vanillaBookshelf.fetchShelfItems();

        this.dialogOpenFile.updateShelfItems(shelfItems).catch(console.warn);
        this.dialogOpenFile.closeOnEscKeyUp = false;

        this.initialVanillaReaderUiOptionsData = await this.vanillaReaderOptionsDataStore.fetchVanillaReaderUiOptionsData() || VanillaReaderAppUiDefaults.options;
        this.dialogSettings.setViewState(this.initialVanillaReaderUiOptionsData);
        // Get default platform voices. These may be overwritten later by a custom TTS implementation.
        // Updates to the voice collection will trigger a `MEDIAPLAYER_VOICE_LIST_CHANGED`.
        const defaultVoicesCollectionData = await WebSpeechUtils.fetchTtsVoices();
        this.dialogSettings.setTtsVoiceCollectionData(defaultVoicesCollectionData);

        let ttsOptions: IVanillaReaderTtsOptions | undefined;

        if (this.initialVanillaReaderUiOptionsData) {

            ttsOptions = this.initialVanillaReaderUiOptionsData.ttsOptions;

            // The user prefers reduced motion, so we will not use movement in our UI transitions.
            if (this.initialVanillaReaderUiOptionsData.useReducedMotion) {
                this.toaster.toast('Using reduced UI animations').catch(console.error);
            }

            if(this.initialVanillaReaderUiOptionsData.readingRulerOptions) {
                this.readingRuler.setOptions(this.initialVanillaReaderUiOptionsData.readingRulerOptions);
                if(this.initialVanillaReaderUiOptionsData.showReadingRuler) {
                    this.showReadingRuler();
                }
            }

            // Grab the initial color palette for the app and apply it.
            let palette: IVanillaReaderUiColorTheme | undefined = VanillaReaderAppAssets.ColorThemes.find(palette => palette.name === this.initialVanillaReaderUiOptionsData?.activeUiPaletteName);

            if(!palette) {
                palette = VanillaReaderAppAssets.ColorThemes.find(palette => palette.name === 'Dark')!;
            }

            if (palette) {
                this.setUiColorTheme(palette);
            }
        }

        this.webSpeechPlayerForTextSelections = await this._createWebSpeechSynthesisPlayerForTextSelections(ttsOptions);
    }

    /**
     *
     * */
    async _composeReadingPositionAnnouncement(): Promise<string | void> {
        if (this.latestContentRangeData) {

            let previousHeadingLandmark: VanillaReaderLandmark | undefined = undefined;
            const latestTimelinePosition = this.latestTimelinePosition;
            let headings = this.publicationHeadingLandmarks;
            let heading: string = '';

            if (headings && latestTimelinePosition) {
                for (let i = headings.length - 1; i >= 0; i--) {
                    let heading: VanillaReaderLandmark = headings[i];
                    let headingTimelinePosition = await heading.fetchTimelinePosition();
                    if (headingTimelinePosition && headingTimelinePosition < latestTimelinePosition) {
                        previousHeadingLandmark = heading;
                        break;
                    }
                }
            }

            if (previousHeadingLandmark) {
                heading = `Closest previous heading "${previousHeadingLandmark.textContent}"`;
            }

            let tocItems: IVanillaReaderNavigationItem[] | undefined = this.latestContentRangeData.navItems.filter((item: IVanillaReaderNavigationItem) => {
                return item.collectionType === NavigationCollectionType.TOC;
            });

            let tocItemTitle = 'Unknown';

            if (tocItems && tocItems.length > 0) {
                tocItemTitle = tocItems[0].title;
            }

            let pageItem: IVanillaReaderSyntheticPageData | undefined;
            let pageNumber = '';
            let paginationTypeLabel = '';

            if(this.publicationPageListData && latestTimelinePosition) {
                pageItem = this.publicationPageListData?.pages.find((page)=>{
                    return (latestTimelinePosition >= page.range.start && latestTimelinePosition < page.range.end) || (latestTimelinePosition === page.range.start && latestTimelinePosition === page.range.end);
                });

                paginationTypeLabel = this.publicationPageListData.paginationType === VanillaReaderPaginationType.SYNTHETIC  ? 'in location' : 'on page';

                if (pageItem) {
                    pageNumber = `${paginationTypeLabel} ${pageItem.label}`;
                }
            }

            let readingProgression = 'Unknown';

            if (this.latestContentRangeData.readingProgression) {
                readingProgression = Math.round(this.latestContentRangeData.readingProgression * 100) + '%';
            }
            const announcement = `You are at ${readingProgression} in "${this.initialPublicationData?.title}"\n\nSection "${tocItemTitle}"\n\n${heading}\n\n${pageNumber}`;
            return Promise.resolve(announcement);
        }
    }

    /**
     *
     * This method creates the `WebSpeechTtsSynthesizer` that is used to speak text selections. It has nothing to do
     * with the "real" TTS, which can be found in the `VanillaReaderMediaPlayer` and the `VanillaReaderWebSpeechTtsSynthesizer`
     *
     * */
    async _createWebSpeechSynthesisPlayerForTextSelections(ttsOptions: IVanillaReaderTtsOptions | undefined): Promise<WebSpeechTtsSynthesizer> {
        let voicesCollection = await WebSpeechUtils.fetchTtsVoices();

        let voices = voicesCollection?.allVoices || [];
        let ttsVoiceName = ttsOptions?.voiceName ? ttsOptions.voiceName : VanillaReaderAppUiDefaults.options?.ttsOptions?.voiceName;


        if (!ttsVoiceName) {
            //console.warn('VanillaReader._createWebSpeechSynthesisPlayer', 'Unable to get voice name from options.');
        }

        // Now we filter out the matching `SpeechSynthesisVoice` instance.
        let ttsVoice = voices.find((voice: SpeechSynthesisVoice) => {
            return ttsVoiceName ?
                voice.name.includes(ttsVoiceName) :
                false;
        });

        let speechSynt = new WebSpeechTtsSynthesizer((utterance: SpeechSynthesisUtterance) => {
            if (ttsVoice) {
                utterance.voice = ttsVoice;
            }
        });

        speechSynt.init(
            {
                onTtsSynthesizerWaiting: () => {
                },
                onUtteranceBoundary: (_utteranceId: number, _startOffset: number, _length: number | null) => {
                },
                onUtteranceEnd: (_utteranceId: number) => {
                    this.fabSpeakText.stateIsSpeaking = false;
                },
                onUtteranceError: (_utteranceId: number, _error: unknown) => {
                    this.fabSpeakText.stateIsSpeaking = false;
                },
                onUtterancePaused: (_utteranceId: number) => {
                    this.fabSpeakText.stateIsSpeaking = false;
                },
                onTtsSynthesizerReady: () => {
                }
            }
        );

        return speechSynt;
    }

    _onAfterPublicationLoadedSetup(publicationData: IVanillaReaderPublicationStateData): void {
        if (this.initialVanillaReaderUiOptionsData?.showNarrationControls || publicationData.hasMoSyncMedia || publicationData.isAudiobook) {
            this.menuMediaPlayer.open();
            this.menuBottom.toggleReadAloudButtonState(true);
            this.fabMediaPlayer.show();
        }

        if ('wakeLock' in navigator) {
            navigator.wakeLock.request('screen').then((sentinel: WakeLockSentinel) => {
                this.screenWakeLockSentinel = sentinel;
            }).catch(console.warn);
        } else {
            console.log('wake lock is not supported');
        }

        if (this.initialVanillaReaderUiOptionsData?.scrollOverflowingTables !== undefined) {
            this.setScrollOverflowingTables(this.initialVanillaReaderUiOptionsData?.scrollOverflowingTables);
        }

        if(this.initialVanillaReaderUiOptionsData?.useAccessibilityMode) {
            this.enterAccessibilityMode();
        }

        this.vanillaReaderAPI.fetchTtsVoiceCollection().then((voicesCollection)=>{
            if(voicesCollection) {
                this.dialogSettings.setTtsVoiceCollectionData(voicesCollection);
            } else {
                console.warn('VanillaReaderUI._createWebSpeechSynthesisPlayer(): Unable to load TTS voices.');
            }
        }).catch(console.warn);


        this.toaster.toast('Press Alt + F1 / Control + Option + F1 to open help text.', true).catch(console.warn);

    }

    _onPublicationRendered(): void {
    }

    _populatePublicationLandmarks(): void {
        this.vanillaReaderAPI.fetchPublicationLandmarks([
            VanillaReaderPublicationLandmarkType.HEADING1,
            VanillaReaderPublicationLandmarkType.HEADING2,
            VanillaReaderPublicationLandmarkType.HEADING3,
            VanillaReaderPublicationLandmarkType.HEADING4,
            VanillaReaderPublicationLandmarkType.HEADING5,
            VanillaReaderPublicationLandmarkType.HEADING6,
            VanillaReaderPublicationLandmarkType.FIGURE,
            VanillaReaderPublicationLandmarkType.IMAGE,
            VanillaReaderPublicationLandmarkType.VIDEO,
            VanillaReaderPublicationLandmarkType.DESCRIPTION_LIST,
            VanillaReaderPublicationLandmarkType.UNORDERED_LIST,
            VanillaReaderPublicationLandmarkType.ORDERED_LIST,
            VanillaReaderPublicationLandmarkType.TABLE,
        ]).catch(console.warn);
    }

    _updateNavigationHistory(readingPositionData: IVanillaReaderContentPositionData): void {

        if(this.navigationHistoryData[0]?.locator === readingPositionData.locator) {
            console.log('VanillaReaderUI._updateNavigationHistory(), reading position is identical to the previous entry.');
            return;
        }

        if (this.navigationHistoryData.length >= 10) {
            this.navigationHistoryData = this.navigationHistoryData.slice(this.navigationHistoryData.length - 10, this.navigationHistoryData.length);
        }
        this.navigationHistoryData.unshift(readingPositionData);

        this.dialogNavigationHistory.populate(this.navigationHistoryData);
    }

    // TypeScript type guard
    _eventDataIsPointerEngineEventData(eventData: PointerEvent | IPointerEngineEventData): eventData is IPointerEngineEventData {
        return (eventData as IPointerEngineEventData).readerViewName !== undefined;
    }

    _eventDataIsMouseEngineEventData(eventData: MouseEvent | IMouseEngineEventData): eventData is IMouseEngineEventData {
        return (eventData as IMouseEngineEventData).readerViewName !== undefined;
    }

    /*
    *
    * CALLBACKS
    *
    * */

    _onPublicationDownloadProgressUpdated(_publicationId: string | undefined, _progress: number): void {};

    _onPublicationDownloaded (publicationId: string | undefined): void {
        this.toaster.toast(`Publication ${publicationId} has been added.`).catch(console.error);
    };

    /*
    *
    * EVENT HANDLERS
    *
    * */

    _uiEvent_uiKeyUp = (ev: KeyboardEvent) => {
        this._handleKeyboardShortcut(ev.key, ev.altKey, ev.shiftKey, ev.ctrlKey);
    };

    _uiEvent_windowResize = (ev: Event) => {
        ev.stopPropagation();

        // A resize can happen when an on-screen keyboard pops up for example. If there is a dialog open, such as the
        // search dialog, we do not refresh the reader view as this can disrupt the user experience. We need to add
        // a reminder however to do a refresh later when the dialog has closed.
        if (!this.activeDialogTitle) {
            // TODO: This should really be a top level event listener, perhaps in the VanillaReaderAppMain class.
            VanillaReaderEventBus.dispatchEvent(VanillaReaderEventBus.createEvent("APP_WINDOW_RESIZED", {srcEvent: ev}));
            this.sendRefreshIntentAfterDialogClosed = false;
        } else {
            this.sendRefreshIntentAfterDialogClosed = true;
        }

        // Re-check if the screen size matches our definition of a mobile screen.
        this.isMobileScreenSize = window.matchMedia('only screen and (max-width: 480px)').matches;

    };

    _uiEvent_uiOptionsReset = (_options: CustomEvent<IVanillaReaderAppEvent_APP_UI_OPTIONS_RESET>) => {
        // As we have reset all options we need to invalidate the `previousUiOptionsData` state variable.
        this.previousUiOptionsData = undefined;
    }

    _applyUiControllerMixins(constructors: any[]): void {
        constructors.forEach((mixinControllerClass: IVanillaReaderUiComponentController) => {

            Object.getOwnPropertyNames(mixinControllerClass.prototype).forEach((name) => {
                Object.defineProperty(
                    this.__proto__,
                    name,
                    Object.getOwnPropertyDescriptor(mixinControllerClass.prototype, name) ||
                    Object.create(null)
                );
            });

            // If the Class has a static instance method called __initialize__ we call this so that the mixin
            // can do initial setup actions.
            let hasInitializer: boolean = Object.getOwnPropertyNames(mixinControllerClass).includes('__initialize__');

            if(hasInitializer) {
                mixinControllerClass.__initialize__(this);
            }
        });
    }

    _findNearestHrefValueInNodeData(nodeData: IEngineEventTargetXmlElementNodeData): string | undefined {
        const _bubblingHrefCheck = (node: IEngineEventTargetXmlElementNodeData): string | undefined => {
            let href: string | undefined = node.attributes?.find(attr => attr?.localName === 'href')?.value;
            if(href) {
                return href;
            }
            if(!node.parent) {
                return;
            }
            return _bubblingHrefCheck(node.parent);
        };

        return _bubblingHrefCheck(nodeData);

    }

}

/**
 * VanillaReaderUI
 *
 * This interface makes the mixin code splitting strategy work in TypeScript.
 *
 * */

export interface VanillaReaderUI extends
    VanillaReaderUiButtonMenuController,
    VanillaReaderUiButtonNextController,
    VanillaReaderUiButtonPreviousController,
    VanillaReaderUiKeyboardShortcutController,
    VanillaReaderUiMenuMediaPlayerController,
    VanillaReaderUiMenuController,
    VanillaReaderUiSideMenuController,
    VanillaReaderUiSliderProgressionController,
    VanillaReaderUiMediaSessionsController,
    VanillaReaderUiDialogUiActionsController,
    VanillaReaderUiDialogController,
    VanillaReaderUiDialogHighlightController,
    VanillaReaderUiDialogHighlightsController,
    VanillaReaderUiDialogBookmarksController,
    VanillaReaderUiDialogOpenFileController,
    MasterPlanUIStartController,
    VanillaReaderUiDialogFootnoteController,
    VanillaReaderUiDialogSettingsController,
    VanillaReaderUiDialogImageViewerController,
    VanillaReaderUiDialogSearchController,
    VanillaReaderUiDialogContentsController,
    VanillaReaderUiDialogNavigationHistoryController,
    VanillaReaderUiVanillaReaderEventController,
    VanillaReaderUiFabHighlightController,
    VanillaReaderUiFabMediaPlayerController,
    VanillaReaderUiReadingRulerController,
    VanillaReaderUiPanZoomToolController,
    VanillaReaderUiDialogPublicationLandmarksController,
    VanillaReaderUiLabelPageNumberController,
    VanillaReaderUiFabSpeakTextController,
    VanillaReaderUiFunctionButtonsController
{
    __proto__: any
}
